export default {"src":"/encomendas-static/_next/static/media/info-icon.790c827d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};